"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAnswerByQuestionName = void 0;
var getAnswerByQuestionName = function getAnswerByQuestionName(patientAnswers, questionName) {
  if (!patientAnswers) {
    return null;
  }
  var patientAnswer = patientAnswers.find(function (_ref) {
    var question = _ref.question;
    return (question === null || question === void 0 ? void 0 : question.name) === questionName;
  });
  return patientAnswer === null || patientAnswer === void 0 ? void 0 : patientAnswer.answer[0];
};
exports.getAnswerByQuestionName = getAnswerByQuestionName;